/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cus_Arranged_Date_QuestionInputs */

const en_cus_arranged_date_question = /** @type {(inputs: Cus_Arranged_Date_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Did you arrange a new date with the customer?`)
};

const ja_cus_arranged_date_question = /** @type {(inputs: Cus_Arranged_Date_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`顧客と新しい日付を合意しましたか？`)
};

const fr_cus_arranged_date_question = /** @type {(inputs: Cus_Arranged_Date_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avez-vous convenu d'une nouvelle date avec le client ?`)
};

const de_cus_arranged_date_question = /** @type {(inputs: Cus_Arranged_Date_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haben Sie mit dem Kunden einen neuen Termin vereinbart?`)
};

/**
* | output |
* | --- |
* | "Did you arrange a new date with the customer?" |
*
* @param {Cus_Arranged_Date_QuestionInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const cus_arranged_date_question = /** @type {((inputs?: Cus_Arranged_Date_QuestionInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cus_Arranged_Date_QuestionInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cus_arranged_date_question(inputs)
	if (locale === "ja") return ja_cus_arranged_date_question(inputs)
	if (locale === "fr") return fr_cus_arranged_date_question(inputs)
	return de_cus_arranged_date_question(inputs)
});